import React from 'react';
import { FormControl, InputLabel, MenuItem, Stack } from '@mui/material';
import SearchableSelect from '../search/SearchableSelect';

export default function FundingPicker({ value, onChange, accounts, categories, templates, nature = 'expense', disabled = false }) {
  return <Stack spacing={2} sx={{ my: 2 }}>
    <FormControl fullWidth required disabled={disabled}>
      <InputLabel id="intake-account-label">Funding account</InputLabel>
      <SearchableSelect labelId="intake-account-label" label="Funding account" value={value.account_id || ''}
        onChange={e => onChange({ account_id: e.target.value, category_id: '', split_template_id: '' })}>
        {accounts.filter(a => !a.plaid_linked && a.account_status !== 'archived' && a.is_active !== false)
          .map(a => <MenuItem value={a.id} key={a.id}>{a.name}</MenuItem>)}
      </SearchableSelect>
    </FormControl>
    <FormControl fullWidth disabled={disabled || !value.account_id}>
      <InputLabel id="intake-split-label">Split template (optional)</InputLabel>
      <SearchableSelect labelId="intake-split-label" label="Split template (optional)" value={value.split_template_id || ''}
        onChange={e => onChange({ ...value, split_template_id: e.target.value, category_id: '' })}>
        <MenuItem value="">No split</MenuItem>
        {templates.filter(t => Number(t.account_id) === Number(value.account_id) && t.transaction_type === nature)
          .map(t => <MenuItem value={t.id} key={t.id}>{t.name}</MenuItem>)}
      </SearchableSelect>
    </FormControl>
    {!value.split_template_id && <FormControl required fullWidth disabled={disabled || !value.account_id}>
      <InputLabel id="intake-category-label">Funding category</InputLabel>
      <SearchableSelect labelId="intake-category-label" label="Funding category" value={value.category_id || ''}
        onChange={e => onChange({ ...value, category_id: e.target.value })}>
        {categories.filter(c => Number(c.account_id) === Number(value.account_id) && !c.is_deleted)
          .map(c => <MenuItem value={c.id} key={c.id}>{c.name}</MenuItem>)}
      </SearchableSelect>
    </FormControl>}
  </Stack>;
}
